import React, { MutableRefObject, useEffect } from 'react'

interface Props {
    onDrag: () => void
    visible: boolean
    offsetX: number
    offsetY: number
    className?: string
    style?: object
    updatePosition?: (buttonRef) => void
    buttonRef?: MutableRefObject<any>
};

const MouseTooltip: React.FC<Props> = ({
    onDrag,
    visible,
    offsetX,
    offsetY,
    className,
    style,
    children,
    updatePosition,
    buttonRef
}) => {
    const [xPosition, setXPosition] = React.useState<number>(0)
    const [yPosition, setYPosition] = React.useState<number>(0)
    const [originalXPosition, setOriginalXPosition] = React.useState<number>(0)
    const [originalYPosition, setOriginalYPosition] = React.useState<number>(0)
    const [mouseMoved, setMouseMoved] = React.useState<boolean>(false)
    const [listenerActive, setListenerActive] = React.useState<boolean>(false)

    useEffect(() => {
        addListener()
    }, [])

    useEffect(() => {
      setOriginalXPosition(xPosition)
      setOriginalYPosition(yPosition)
    }, [visible])

    useEffect(() => {
        if (listenerActive && visible) {
          addListener();
        }
    
        if (listenerActive && !visible) {
          removeListener();
        }
    }, [listenerActive, visible])

    const getTooltipPosition = ({ clientX: xPosition, clientY: yPosition }) => {
        setXPosition(xPosition)
        setYPosition(yPosition)
        setMouseMoved(true)
        if (updatePosition && buttonRef) {
          updatePosition(buttonRef.current)
        }
        if (onDrag) {
          onDrag()
        } 
    };

    const addListener = () => {
        window.addEventListener('mousemove', getTooltipPosition);
        setListenerActive(true);
    };

    const removeListener = () => {
        window.removeEventListener('mousemove', getTooltipPosition);
        setListenerActive(false);
    };

    return (
      <div
        className={className}
        style={{
          display: visible && mouseMoved ? 'block' : 'none',
          position: 'fixed',
          top: yPosition + (yPosition < originalYPosition ? -offsetY : offsetY),
          left: xPosition + (xPosition < originalXPosition ? -offsetX : offsetX),
          ...style,
        }}
      >
        {children}
      </div>
    )
}

export default MouseTooltip;
